import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to New Orleans or Atlanta needed",
      "Ideal for Port of Mobile cruise passengers",
      "Perfect for Austal USA engineers flying to Perth",
      "Great for USA medical students on international rotations",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Mobile post offices",
      "Good for planned international trips from the Gulf Coast",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Mobile or Tillmans Corner USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agencies: New Orleans (~145 mi) or Atlanta (~330 mi)",
      "NPIC appointment required before traveling",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function MobileProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Mobile"
      introText="Mobile travelers — Port of Mobile cruise passengers heading to the Caribbean, Austal USA shipyard engineers flying to Perth and the Philippines, University of South Alabama medical students doing international rotations, and Gulf Coast families heading to Cancun — have several options for getting a passport fast. Here is how they compare, and why most Alabama Gulf Coast residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to New Orleans or Atlanta."
      options={options}
      emergencyDescription="Mobile does not have its own regional passport agency. The closest are New Orleans (~145 miles west on I-10, 2+ hours) and Atlanta (~330 miles northeast, 5+ hours). I-10 construction through the Mississippi state line and Mobile Bay traffic on the Wallace Tunnel and Bayway add unpredictable delays. During hurricane season, evacuation traffic on I-10 can make New Orleans inaccessible for days."
      disclaimerText="*Processing speed depends on eligibility and documentation. Mobile does not have a regional passport agency — the closest are New Orleans and Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}